// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-label[data-v-1c9fcc80] {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  margin-bottom: 8px;\n  color: #333332;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
